import { render, staticRenderFns } from "./lifecycle.vue?vue&type=template&id=256d758a&"
import script from "./lifecycle.vue?vue&type=script&lang=js&"
export * from "./lifecycle.vue?vue&type=script&lang=js&"
import style0 from "./lifecycle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports